import React from "react";
import { View, Text } from "@react-pdf/renderer";

const RankTrackingProjectPdf = ({ project_data, competitor = true }) => {
  if (!project_data) return null;
  return (
    <View style={{ marginBottom: 30 }}>
      <View
        style={{
          flexDirection: "row",
          marginBottom: 10,
          justifyContent: "space-between",
        }}
      >
        <View style={{ flexDirection: "row" }}>
          <Text
            style={{
              fontSize: 12,
              color: "#00000099",
              fontWeight: 400,
            }}
          >
            {competitor ? "Project Name(Domain): " : "Project Name: "}
          </Text>
          <Text
            style={{
              fontSize: 12,
              color: "#000000",
              fontWeight: 500,
            }}
          >
            {project_data?.project}
          </Text>
        </View>

        {project_data?.lastUpdatedTime && (
          <View style={{ flexDirection: "row" }}>
            <Text
              style={{
                fontSize: 12,
                color: "#00000099",
                fontWeight: 400,
              }}
            >
              Date :{" "}
            </Text>
            <Text
              style={{
                fontSize: 12,
                color: "#000000",
                fontWeight: 500,
              }}
            >
              {project_data.lastUpdatedTime}
            </Text>
          </View>
        )}
      </View>

      {project_data?.language && (
        <View style={{ flexDirection: "row", marginBottom: 10 }}>
          <Text
            style={{
              fontSize: 12,
              color: "#00000099",
              fontWeight: 400,
            }}
          >
            Project Language :{" "}
          </Text>
          <Text
            style={{
              fontSize: 12,
              color: "#000000",
              marginLeft: 5,
              textTransform: "capitalize",
              fontWeight: 500,
            }}
          >
            {project_data.language}
          </Text>
        </View>
      )}

      {project_data?.location && (
        <View style={{ flexDirection: "row", marginBottom: 10 }}>
          <Text
            style={{
              fontSize: 12,
              color: "#00000099",
              fontWeight: 400,
            }}
          >
            Project Location :{" "}
          </Text>
          <Text
            style={{
              fontSize: 12,
              color: "#000000",
              marginLeft: 5,
              fontWeight: 500,
            }}
          >
            {project_data.location?.map((location, index) => {
              return (
                <React.Fragment key={"location" + index}>
                  {index !== 0 ? ", " : ""}
                  {location}
                </React.Fragment>
              );
            })}
          </Text>
        </View>
      )}

      {project_data?.deviceType && (
        <View style={{ flexDirection: "row" }}>
          <Text
            style={{
              fontSize: 12,
              color: "#00000099",
              fontWeight: 400,
            }}
          >
            Device Type :{" "}
          </Text>
          <Text
            style={{
              fontSize: 12,
              color: "#000000",
              marginLeft: 5,
              textTransform: "capitalize",
              fontWeight: 500,
            }}
          >
            {project_data.deviceType}
          </Text>
        </View>
      )}
    </View>
  );
};

export default RankTrackingProjectPdf;
